__turbopack_context__.v({
  "animate-arrow-hover": "bEDJYa_animate-arrow-hover",
  "arrow-hover": "bEDJYa_arrow-hover",
  "arrow-up-right-icon": "bEDJYa_arrow-up-right-icon",
  "popover-item": "bEDJYa_popover-item",
});
